import Skeleton from '@mui/material/Skeleton';
import { Box } from 'shared/mui/Box';

import {
  OrderConversionChartProvidersRatioHintBox,
  OrderConversionChartProvidersRatioScrollBox,
  StyledBox,
  StyledCard,
  StyledCardContent,
} from './OrderConversionChartProvidersRatio.styled';

const BarSkeleton: React.FC = () => (
  <Box>
    <Box sx={{ display: 'flex', justifyContent: 'space-between', paddingBottom: '2px' }}>
      <Skeleton height={16} variant="text" width="40%" />
      <Skeleton height={16} variant="text" width="30%" />
    </Box>
    <Skeleton height={8} variant="rectangular" width="100%" />
  </Box>
);

export const OrderConversionChartProvidersRatioSkeleton: React.FC = () => (
  <StyledCard>
    <Box
      sx={{
        height: '80px',
        padding: '16px',
        borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: '8px',
      }}
    >
      <Skeleton height={20} variant="text" width="50%" />
      <Skeleton height={16} variant="text" width="70%" />
    </Box>
    <StyledCardContent>
      <StyledBox>
        <BarSkeleton />
      </StyledBox>
      <OrderConversionChartProvidersRatioScrollBox>
        {Array.from({ length: 5 }).map((_, index) => (
          <BarSkeleton key={index} />
        ))}
      </OrderConversionChartProvidersRatioScrollBox>
      <OrderConversionChartProvidersRatioHintBox>
        <Skeleton height={16} variant="text" width={80} />
        <Skeleton height={16} variant="text" width={80} />
        <Skeleton height={16} variant="text" width={80} />
      </OrderConversionChartProvidersRatioHintBox>
    </StyledCardContent>
  </StyledCard>
);
